module.exports = "/_next/static/images/game-1-intro-uv-landing-21e4f79495356890bc30661e16da432b.png";